export default __webpack_public_path__ + "static/media/CICA Dark.b4bbf30c.svg";